import Lottie from 'lottie-react';
import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const StyledLottie = styled(Lottie)`
  width: 200px;
  height: 200px;
  align-self: center;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
`;

export const TitleText = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;
